/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcRaglV1ManualEntryState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_RAGL_V1_MANUAL_ENTRY_STATE_ENTITY_NAME = 'ixc.ragl.v1.ManualEntry';
export const ixcRaglV1ManualEntryStateEntity = new schema.Entity<IxcRaglV1ManualEntryState>(IXC_RAGL_V1_MANUAL_ENTRY_STATE_ENTITY_NAME, {}, { idAttribute: 'entryId' });

